export class CreateLinkParams {
  module: string
  target: string
  zone: string
  owner: string
  expiresAt: string | null

  constructor({ module, target, zone, owner, expiresAt }: { module: string, target: string, zone: string, owner: string, expiresAt: string | null }) {
    this.module = module
    this.target = target
    this.zone = zone
    this.owner = owner
    this.expiresAt = expiresAt
  }
}
